import { DeviceType } from "app/models/device.model";

export interface DeviceModelCatalogEntry {
    model: string;
    deviceType: DeviceType;
    defaultProtocol?: string;
}

export interface DeviceManufacturerCatalogEntry {
    aliases?: string[];
    models: DeviceModelCatalogEntry[];
}

export const DEVICE_MODEL_CATALOG: Record<string, DeviceManufacturerCatalogEntry> = {
    CESVA: {
        models: [
            {
                model: "TA120",
                deviceType: DeviceType.NoiseSensor,
                defaultProtocol: "json",
            },
            {
                model: "TA150",
                deviceType: DeviceType.NoiseSensor,
                defaultProtocol: "json",
            },
            {
                model: "LF010",
                deviceType: DeviceType.AcousticLimiter,
                defaultProtocol: "json",
            },
            {
                model: "LRF-04",
                deviceType: DeviceType.AcousticLimiter,
                defaultProtocol: "xlsx",
            },
            {
                model: "LRF-05",
                deviceType: DeviceType.AcousticLimiter,
                defaultProtocol: "xlsx",
            },
        ],
    },
    Svantek: {
        models: [{ model: "307", deviceType: DeviceType.NoiseSensor }],
    },
    "Brüel & Kjaer": {
        aliases: ["Brüel & Kjær"],
        models: [{ model: "2270", deviceType: DeviceType.NoiseSensor }],
    },
    SPXOne: {
        aliases: ["Glove Systems"],
        models: [{ model: "SPXOne", deviceType: DeviceType.AcousticLimiter }],
    },
    "NTi Audio": {
        models: [{ model: "XL3", deviceType: DeviceType.NoiseSensor }],
    },
};
